import { useEffect } from "react";

const SITE = "Virality";

/**
 * Sets document.title for the current page.
 * Format: "Page Name — Virality"
 * Pass null / undefined to reset to the base site title.
 */
export function usePageTitle(pageTitle) {
  useEffect(() => {
    document.title = pageTitle ? `${pageTitle} — ${SITE}` : SITE;
    return () => {
      document.title = SITE;
    };
  }, [pageTitle]);
}
